export default "__VITE_ASSET__BbMQfj3c__"